export default ({ theme }) => ({
    display: 'inline',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    '> img': {
        height: `${theme.sizes.header - 1}rem`,
        borderRadius: '8px',
    },
});
